import { render, staticRenderFns } from "./CartPosition.vue?vue&type=template&id=1d0faf9c"
import script from "./CartPosition.vue?vue&type=script&lang=ts"
export * from "./CartPosition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports